import { EditableText } from '@/components/editor/EditableText';

interface MnemonicBoxProps {
  text: string;
  icon?: string;
  onTextCommit?: (next: string) => void;
}

/**
 * The dashed-blue Caveat box at the bottom of a Dessinée fiche.
 * `**bold**` is rendered via EditableText's markdown-lite renderer in read mode.
 */
export function MnemonicBox({ text, icon = '🧠', onTextCommit }: MnemonicBoxProps) {
  return (
    <div
      className="mt-4 rounded-card px-[14px] py-[10px] pb-2 font-caveat text-[20px] text-accent-blue flex items-center gap-[10px]"
      style={{
        border: '2.5px dashed #2e6cb5',
        background: 'rgba(46,108,181,.07)',
      }}
    >
      <span>{icon}</span>
      <EditableText
        value={text}
        boldColor="#1f2330"
        ariaLabel="Mnémo"
        onCommit={(next) => onTextCommit?.(next)}
      />
    </div>
  );
}
